<template>
    <b-modal id="modal-media" centered class="modal-media">
        <div class="modal-media-itens">
            <button class="modal-media-itens-close" @click="$bvModal.hide('modal-media')">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.78" height="21.15" viewBox="0 0 18.78 21.15">
                    <g id="Grupo_1753" data-name="Grupo 1753" transform="translate(-411.263 -553.556)">
                        <g id="Grupo_1413" data-name="Grupo 1413" transform="translate(403.688 564.131) rotate(-45)">
                            <path id="União_2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                                transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                                stroke-linejoin="round" stroke-width="3" />
                        </g>
                        <g id="Grupo_1593" data-name="Grupo 1593" transform="translate(437.617 564.131) rotate(135)">
                            <path id="União_2-2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                                transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                                stroke-linejoin="round" stroke-width="3" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>
        <div class="modal-media-iframe">
            <iframe id="media" :src="mediaUrl" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: ["video"],
    computed: {
        mediaUrl() {
            return this.video;
        },
    },
};
</script>

<style lang="scss">
#modal-media {

    .modal-header,
    .modal-footer {
        display: none;
    }

    .modal-dialog {
        max-width: 1255px;
        max-height: 825px;
        margin: auto !important;

        @media screen and (max-width: 991px) {
            max-width: 384px;
        }
    }

    .modal-content {
        border-radius: 0;
        border: 0;
    }

    .modal-body {
        padding: 3rem 5rem 3rem 5rem;
        max-height: 945px;
        display: flex;
        flex-direction: column;

        @media (max-width: 991px) {
            padding: 30px 20px;
            max-height: 754px;
        }
    }
}

.modal-media {
    &-itens {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;

        &-close {
            width: 62px;
            height: 53px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--white);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            transition: 500ms;
            margin-bottom: 3rem;

            @media (max-width: 991px) {
                top: 20px;
                right: 20px;
                width: 40px;
                height: 40px;

                svg {
                    max-width: 15px;
                }
            }

            &:hover,
            &:focus {
                opacity: 0.6;
            }
        }
    }

    &-iframe {
        iframe {
            width: 100%;
            height: 62rem;
            border: 0;

            @media (max-width: 991px) {
                height: 45rem;
            }
        }

        overflow-y: auto;
    }
}
</style>
